import { deleteApi, getApi, postApi, putApi } from "../../common/api";

export const addProperties = (data: any) => {
    return postApi('/api/property', data);
};

export const editProperties = (data: any, id: any) => {
    return putApi('/api/property/' + id, data);
};

export const listProperties = (params: string = "") => {
    return getApi('/api/property', params);
};
export const deleteProperties = (id: any) => {
    return deleteApi("/api/property/" + id);
};
export const getByIDProperties = (id: any) => {
    return getApi("/api/property/" + id);
};
export const getEvaluations = () => {
    return getApi("/api/evaluations/");
};
export const deleteEvaluations = (id: any) => {
    return deleteApi("/api/evaluations/" + id);
};
export const getViews = (country: string) => {
    const endpoint = country === 'india' ? "/api/arrange/indian-views" : "/api/arrange/all-views";
    return getApi(endpoint);
};

export const removeView = (id: any) => {
    return deleteApi("/api/arrange/remove-view/" + id)
}
export const removeEnquiry = (id: any) => {
    return deleteApi("/api/liveChat/" + id)
}
export const getEnquiry = () => {
    return getApi("/api/liveChat");
};